<template>
  <div id="app">
      <div class="wrapper" v-if="loggedIn && showWrapper">
        <left-sidebar/>
        <div class="content-page">
          <div class="content">
            <top-bar/>
            <div class="container-fluid">
              <router-view/>
            </div>
            <Confirmation/>
            <Prompt/>
          </div>
        </div>
      </div>
      <template v-else>
        <router-view/>
      </template>
  </div>
</template>

<script>
  import LeftSidebar from '@/components/LeftSidebar'
  import TopBar from '@/components/TopBar'
  import Confirmation from '@/components/Confirmation'
  import Prompt from '@/components/Prompt'

  export default {
    name: 'App',
    components: {TopBar, LeftSidebar, Confirmation, Prompt},
    data() {
      return {
        showWrapper: !this.$router.currentRoute.meta.noWrapper
      }
    },
    computed: {
      loggedIn() {
        return this.$store.state.user
      }
    },
    watch: {
      '$route'() {
        this.showWrapper = !this.$router.currentRoute.meta.noWrapper
      }
    }
  }
</script>
